import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ProjectGetter } from '@/store/project/project.module';
import { Project, BudgetForm } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';
import BudgetFormComponent from '@/components/project/create/createComponents/budgetForm/BudgetForm.vue';

export default defineComponent({
  name: 'BudgetModalComponent',
  components: {
    BaseModalComponent,
    BudgetFormComponent,
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },
  emits: [
    'validated'
  ],
  setup: (props, context) => {
    const store = useStore();
    const budgetModal = ref<InstanceType<typeof BaseModalComponent>>();
    const form = ref<InstanceType<typeof BudgetFormComponent>>();
    const isLoading = computed<boolean>(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');

    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const budgetForm = computed<BudgetForm[]>(() => project.value
      ? project.value.projectBudgets
        .map(m => {
          return {
            budgetTypeId: m.id,
            budgetTypeName: m.shortName,
            amount: m.amount,
          };
        })
      : []);

    // show modal
    const show = () => {
      budgetModal.value?.show();
    };

    // hide modal
    const hide = () => {
      budgetModal.value?.hide();
    };

    const submitClick = () => {
      form.value?.submitForm();
    };

    const validated = (budgetData: BudgetForm[]) => {
      context.emit('validated', budgetData);
      hide();
    };

    const clearForm = () => {
      form.value?.clearForm();
    };

    return {
      budgetModal,
      form,
      isLoading,
      budgetForm,
      show,
      hide,
      submitClick,
      validated,
      clearForm
    };
  },
});
